<template>
    <v-dialog-old ref="modalBoxDialog" id="modalBoxDialog" :class="dialogClass" @hidden="onClose">
        <div class="dialog-container" v-html="message"></div>
        <template v-slot:footer>
            <div class="buttons">
                <div class="left">
                    <button @click="handleConfirm" :class="'btn-norm ' + confirmButton.btnClass" type="submit">
                        {{ confirmButton.name }}
                    </button>
                </div>
                <div class="right">
                    <button v-if="showDeclineButton" :class="'btn-norm ' + declineButton.btnClass" @click="handleDecline">
                        {{ declineButton.name }}
                    </button>
                </div>
            </div>
        </template>
    </v-dialog-old>
</template>

<script>
import { events } from "./events";

export default {
    name: "ModalBox",

    data: function () {
        return {
            message: '',

            confirmButton: {
                name: "OK",
                callback: () => {},
                btnClass: 'green',
            },

            declineButton: {
                name: "Отмена",
                callback: () => {},
                btnClass: '',
            },

            showDeclineButton: true,

            dialogClass: '',

            declineOnClose: true,
        };
    },

    methods: {
        clearState: function () {
            this.confirmButton = {
                name: "OK",
                btnClass: 'green',
                callback: () => {}
            };

            this.declineButton = {
                name: "Отмена",
                callback: () => {}
            };

            this.message = '';
        },

        handleOpen: function (message, confirmConfig, declineConfig, showDeclineButton, dialogClass, declineOnClose) {
            this.clearState();

            this.message = message;

            Object.entries(confirmConfig).forEach(([key, value]) => {
                this.confirmButton[key] = value;
            });

            Object.entries(declineConfig).forEach(([key, value]) => {
                this.declineButton[key] = value;
            });

            this.showDeclineButton = showDeclineButton;

            this.dialogClass = dialogClass;

            this.declineOnClose = declineOnClose;

            this.$refs.modalBoxDialog.show();
        },

        handleClose: function (isDeclineOrConfirm = false) {
            this.$refs.modalBoxDialog.hide();
            this.onClose(isDeclineOrConfirm);
        },

        onClose: function (isDeclineOrConfirm = false) {
            if (!isDeclineOrConfirm && this.declineOnClose) {
                this.declineButton.callback();
            }
        },

        handleConfirm: function () {
            this.handleClose(true);
            this.confirmButton.callback();
        },

        handleDecline: function () {
            this.handleClose(true);
            this.declineButton.callback();
        }
    },

    mounted: function () {
        events.$on('open', this.handleOpen);
        events.$on('close', this.handleClose);
    }
}
</script>

<style>
#modalBoxDialog {
    max-width: 30%;
}

.buttons {
    display: flex;
    justify-content: center;
}

.buttons > .left {
    margin-right: 10px;
}
.btn-norm {
    min-width: 75px;
    height:35px
}

.only-text-dialog #modalBoxDialog {
    padding: 10px 25px;
}

.width-50-dialog #modalBoxDialog {
    max-width: 50%;
}

</style>
